module.exports = __webpack_public_path__ + "static/media/slide1.913f5b04.jpg";